import { useEffect } from 'react';

import useStore from '../store/useStore';

const saveSearchPhrases = phrases => {
  try {
    const jsonData = { searchedTexts: phrases.map(phrase => ({ text: phrase })) };
    const blob = new Blob([JSON.stringify(jsonData)], { type: 'application/json' });
    navigator.sendBeacon(process.env.REACT_APP_API_ENDPOINT + 'Events/SaveSearch', blob);
  } catch (error) {
    // Ignore any errors
  }
};

function InitialData() {
  const setGolfamoreUser = useStore(state => state.setGolfamoreUser);

  useEffect(() => {
    // Don't remove it if we are on payment page since Stripe redirects
    // and we then loose Golfamore data
    if (!window.location.href.includes('/booking/pay/')) {
      setGolfamoreUser(null);
      document.body.classList.remove('golfhaftet');
    }
  }, [setGolfamoreUser]);

  useEffect(() => {
    const storeUnSubscribe = useStore.subscribe(
      state => state.searchPhrases,
      searchPhrases => {
        if (searchPhrases.length > 10) {
          useStore.getState().clearSearchPhrases();
          saveSearchPhrases(searchPhrases);
        }
      }
    );

    const handleBeforeUnload = () => {
      const store = useStore.getState();
      if (store.searchPhrases.length > 0) {
        store.clearSearchPhrases();
        saveSearchPhrases(store.searchPhrases);
      }
      storeUnSubscribe();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      storeUnSubscribe();
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return null;
}

export default InitialData;
